import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  COMMISSIONS_GET_POLICY_SUCCESS,
  COMMISSIONS_GET_POLICY_FAILURE
} from '../constants'

export function* getPolicySaga({ data: { id }}) {
  try {
      const result =  yield call(BFFAgent.Commission.getPolicy,id)
      yield put({
          type: COMMISSIONS_GET_POLICY_SUCCESS,
          data: result
      })
  } catch (error) {
    yield put({
      type: COMMISSIONS_GET_POLICY_FAILURE,
      data: { error }
    })
  }
}